import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import partnershipData from "../../JsonData/partnershipData.json";
import ContactForm from "../../Components/ContactForm";
const Partnership = () => {
  const scrollRef = useRef(null);
  
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const slideInFromBottom = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.8, ease: "easeOut" },
  };

  const imageList = [
    "/images/Partnership/img1.webp",
    "/images/Partnership/img2.webp",
    "/images/Partnership/img3.webp",
    "/images/Partnership/img4.webp",
    "/images/Partnership/img5.webp",
    "/images/Partnership/img6.webp",
  ];

useEffect(() => {
  const container = scrollRef.current;
  if (!container) return;

  let animationId;
  const step = 3; // Increase this to make scroll faster

  const scroll = () => {
    if (!container) return;

    if (container.scrollLeft >= container.scrollWidth / 2) {
      container.style.scrollBehavior = "auto";
      container.scrollLeft = 0;
      container.style.scrollBehavior = "smooth";
    } else {
      container.scrollLeft += step;
    }

    animationId = requestAnimationFrame(scroll);
  };

  const imgs = container.querySelectorAll("img");
  let loaded = 0;

  const checkStart = () => {
    loaded++;
    if (loaded === imgs.length) {
      scroll(); // Start after all images loaded
    }
  };

  imgs.forEach((img) => {
    if (img.complete) {
      checkStart();
    } else {
      img.addEventListener("load", checkStart);
    }
  });

  return () => cancelAnimationFrame(animationId); // Cleanup
}, []);


 

  return (
    <>
      <section className="w-full flex flex-col justify-center items-center bg-[#143230] lg:h-[797px] h-[795px] px-4">
        <div className="flex flex-col lg:flex-row gap-y-10 lg:gap-x-[112px] ">
          <div className="w-full h-[224px] mt-[156px] lg:ml-[20px] gap-[32px] lg:w-[556px] lg:h-[304px] lg:mt-[274px]  flex flex-col">
            <div className="w-full h-[152px]  gap-[16px] lg:w-[556px] lg:h-[224px] flex flex-col ">
              <div className="w-full h-[76px] lg:w-[556px] lg:h-[136px]">
                <h1 className=" text-[#F9F9F9]">
                  <span className="font-lora font-medium text-[28px] leading-[38px] tracking-[0] lg:text-[52px] lg:leading-[68px] lg:tracking-[-0.01em]">
                    Be a Partner with{" "}
                  </span>
                  <br />
                  <span className="font-outfit font-medium text-[28px] leading-[38px] tracking-[0] lg:text-[52px] lg:leading-[68px]">
                    ZNORM{" "}
                  </span>
                  <span className="font-outfit font-light text-[28px] leading-[38px] tracking-[0] lg:text-[52px] lg:leading-[68px]">
                    HOMES
                  </span>
                </h1>
              </div>

              <div className="w-full h-[60px] lg:w-[556px] lg:h-[72px]">
                <p className="font-outfit font-[350] text-[12px] leading-[20px] tracking-[0] text-[#FFFFFF] lg:text-[16px] lg:leading-[24px]">
                  Partner with ZNORM Homes to maximise your property's
                  potential. We handle bookings, maintenance, and guest
                  care—delivering hassle-free income, transparency, and full
                  owner flexibility.
                </p>
              </div>
            </div>
            <div className="w-[148px] h-[48px] flex items-center justify-center gap-[10px] border border-[#FFFFFF] shadow-[0px_2px_12px_0px_#00000026] px-[12px] py-[10px]">
              <span className="w-[103px] h-[22px] font-outfit font-normal text-[16px] leading-[22px] text-center capitalize text-[#FFFFFF] ">
                Join Our Team
              </span>
            </div>
            {/* three circles */}
           <div className="absolute flex gap-[24px] lg:gap-[32px]  w-[348px]  h-[100px] lg:h-[156px] lg:w-[532px] lg:top-[719px] top-[745px]  ">
              <div className="flex flex-col  items-center justify-center lg:w-[156px] lg:h-[156px] w-[100px] h-[100px] bg-[#94BB6D]  text-white rounded-full lg:border-[8px] border-[5px] border-white">
                {/* <div className="flex items-center justify-center  lg:w-[156px] lg:h-[156px] w-[100px] h-[100px] bg-[#94BB6D] text-white rounded-full border-[8px] border-white"> */}

                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="lg:w-[36px] lg:h-[36px] w-[20px] h-[20px] "
                >
                  <path
                    d="M22.5 31.5V19.5C22.5 19.1022 22.342 18.7206 22.0607 18.4393C21.7794 18.158 21.3978 18 21 18H15C14.6022 18 14.2206 18.158 13.9393 18.4393C13.658 18.7206 13.5 19.1022 13.5 19.5V31.5"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.5 15C4.4999 14.5636 4.595 14.1324 4.77868 13.7365C4.96236 13.3407 5.2302 12.9896 5.5635 12.708L16.0635 3.70945C16.605 3.25182 17.291 3.00073 18 3.00073C18.709 3.00073 19.395 3.25182 19.9365 3.70945L30.4365 12.708C30.7698 12.9896 31.0376 13.3407 31.2213 13.7365C31.405 14.1324 31.5001 14.5636 31.5 15V28.5C31.5 29.2956 31.1839 30.0587 30.6213 30.6213C30.0587 31.1839 29.2956 31.5 28.5 31.5H7.5C6.70435 31.5 5.94129 31.1839 5.37868 30.6213C4.81607 30.0587 4.5 29.2956 4.5 28.5V15Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div className=" flex flex-col items-center text-center gap-[2px]">
                  <span className=" font-outfit font-medium lg:text-[32px] lg:leading-[32px] text-[22px] leading-[22px] tracking-[0px] text-white">
                    25+
                  </span>
                  <span className=" font-outfit font-[350] lg:text-[12px] text-[10px] lg:leading-[16px]  leading-[12px] tracking-[0%] text-white whitespace-nowrap">
                    Holiday Homes
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center lg:w-[156px] lg:h-[156px] w-[100px] h-[100px] bg-[#94BB6D] text-white rounded-full lg:border-[8px] border-[5px] border-white">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="lg:w-[36px] lg:h-[36px] w-[20px] h-[20px]"
                >
                  <path
                    d="M30 15C30 22.4895 21.6915 30.2895 18.9015 32.6985C18.6416 32.8939 18.3252 32.9996 18 32.9996C17.6748 32.9996 17.3584 32.8939 17.0985 32.6985C14.3085 30.2895 6 22.4895 6 15C6 11.8174 7.26428 8.76516 9.51472 6.51472C11.7652 4.26428 14.8174 3 18 3C21.1826 3 24.2348 4.26428 26.4853 6.51472C28.7357 8.76516 30 11.8174 30 15Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 19.5C20.4853 19.5 22.5 17.4853 22.5 15C22.5 12.5147 20.4853 10.5 18 10.5C15.5147 10.5 13.5 12.5147 13.5 15C13.5 17.4853 15.5147 19.5 18 19.5Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div className="flex flex-col items-center gap-[2px]">
                  <span className="  font-outfit font-medium lg:text-[32px] lg:leading-[32px]  text-[22px] leading-[22px] tracking-[0px] text-white">
                    3+
                  </span>
                  <span className=" font-outfit font-[350] lg:text-[12px] lg:leading-[16px] text-[10px] leading-[12px] tracking-[0%] text-white">
                    Countries
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center lg:w-[156px] lg:h-[156px] w-[100px] h-[100px] bg-[#94BB6D] text-white rounded-full lg:border-[8px] border-[5px] border-white">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="lg:w-[36px] lg:h-[36px] w-[20px] h-[20px]"
                >
                  <path
                    d="M27 31.5C27 28.3174 25.7357 25.2652 23.4853 23.0147C21.2348 20.7643 18.1826 19.5 15 19.5C11.8174 19.5 8.76516 20.7643 6.51472 23.0147C4.26428 25.2652 3 28.3174 3 31.5"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15 19.5C19.1421 19.5 22.5 16.1421 22.5 12C22.5 7.85786 19.1421 4.5 15 4.5C10.8579 4.5 7.5 7.85786 7.5 12C7.5 16.1421 10.8579 19.5 15 19.5Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M32.9992 30C32.9992 24.945 29.9992 20.25 26.9992 18C27.9853 17.2602 28.7739 16.2887 29.2951 15.1715C29.8162 14.0542 30.054 12.8258 29.9872 11.5947C29.9205 10.3637 29.5513 9.16818 28.9124 8.11385C28.2735 7.05952 27.3846 6.17894 26.3242 5.55005"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div className="flex flex-col items-center gap-[2px] text-center">
                  <span className=" font-outfit font-medium lg:text-[32px] lg:leading-[32px]  text-[22px] leading-[22px] tracking-[0px] text-white">
                    10K+
                  </span>
                  <span className=" font-outfit font-[350] lg:text-[12px] lg:leading-[16px] text-[10px] leading-[12px]  tracking-[0%] text-white">
                    Guests
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full">
            {/* Mobile View */}

            <div
              className="lg:hidden w-full h-auto relative   rounded-[14px]"
              style={{ marginLeft: "-8px" }}
            >
              <img
                src="/images/Partnership/image1.webp"
                alt="Example"
                className="w-[334px] h-[220px] object-cover rounded-[10px]"
              />
            </div>

            <div className="hidden lg:block w-full h-[432px] mt-[196px]">
              <img
                src="/images/Partnership/image1.webp"
                alt="Example"
                className="w-full h-full object-cover rounded-[14px]"
              />
            </div>
          </div>
        </div>
      </section>

     <section className="flex flex-col justify-center items-center text-center pt-[120px] lg:pt-[300px]">
  <div className="w-full h-[52px] lg:w-[1300px] lg:h-[214px] mt-20 lg:mt-0">
    <h2 className="font-lora font-medium text-[18px] leading-[26px] tracking-[0px] text-center text-[#151515] lg:text-[38px] lg:leading-[100%]">
  Property Listing & <br className="block lg:hidden" />
  Management Everywhere
</h2>


   <div
  ref={scrollRef}
  style={{
    overflowX: "auto",
    scrollBehavior: "smooth",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  }}
  className="flex gap-[12px] lg:gap-14 mt-6 lg:mt-[96px] no-scrollbar"
>
  {[...imageList, ...imageList].map((src, index) => (
    <div
      key={index}
      className="flex-shrink-0 w-[33.33%] max-w-[33.33%] h-[40px] lg:w-[208px] lg:h-[52px] relative flex items-center justify-center"
    >
      <motion.img
        src={src}
        alt={`Partnership ${index + 1}`}
        className="object-contain w-full h-full"
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 75 }}
      />
    </div>
  ))}
</div>


  </div>
</section>


      <section className="flex flex-col justify-center items-center w-full h-[1120px]  lg:h-[1066px]  mt-[120px] lg:mt-[200px] lg:px-[106px] lg:py-[160px] lg:gap-[10px] bg-[#F1F3ED]">
        <div className="inline-flex flex-col lg:flex-row  items-center lg:items-start  justify-center lg:justify-start  w-[362px] lg:w-[1300px] h-[880px] lg:h-[746px] gap-[48px] lg:gap-[189px]  mt-[120px] mb-[120px] ml-[16px] mr-[16px] lg:mt-[160px] lg:ml-0 lg:mb-[214px] ">
          <div className="flex flex-col lg:w-[445px] lg:h-[209px] items-start    ">
            <div className="flex flex-col lg:w-[411px] lg:h-[103px] items-start gap-[12px] lg:gap-[32px]    ">
              <div className="flex items-end gap-2 relative self-stretch w-full flex-[0_0_auto] ">
                <div className="relative w-[167px] h-[22px] font-lora font-medium text-[24px] leading-[22px] tracking-[0px] text-[#151515] whitespace-nowrap ml-[60px] lg:ml-0">
                  The Advantage
                </div>

                <svg
                  width="64"
                  height="1"
                  viewBox="0 0 64 1"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="relative mb-[-0.50px]"
                >
                  <line
                    y1="0.75"
                    x2="64"
                    y2="0.75"
                    stroke="#151515"
                    strokeOpacity="0.9"
                    strokeWidth="0.9"
                  />
                </svg>
              </div>

              <div className="relative self-stretch font-lora font-medium text-[#151515] text-[32px] tracking-[0] leading-[normal]">
                <div className="relative w-[187px] lg:w-[411px] h-[26px] lg:h-[49px] font-lora font-medium text-[18px] lg:text-[38px] leading-[26px] lg:leading-[100%] ml-[60px] lg:ml-0 tracking-[0px] text-[#151515]">
                  Why Choose ZNORM?
                </div>
              </div>
            </div>

            <p className="relative w-[317px] lg:w-[445px] h-[60px] lg:h-[66px] font-outfit font-[350] text-[12px] lg:text-[16px] leading-[20px] lg:leading-[22px] tracking-[0] lg:tracking-[-0.2px] text-center lg:text-left text-[#767676] mt-[16px] lg:mt-[20px]">
              ZNORM redefines property hosting by combining peace of mind,
              profitability, and personal control. With us, your home isn't just
              listed — it's elevated.
            </p>
          </div>

          <div
            className="flex flex-col items-start 
      w-[362px] lg:w-[666px] h-[704px] lg:h-[746px] 
      gap-4 lg:gap-[32px] relative overflow-y-auto "
          >
            <div className="flex flex-col w-[362px] lg:w-[666px] h-[164px] lg:h-[746px] items-center justify-center gap-4 p-6 relative bg-white rounded-[12px] border border-[#ebebeb] shadow-[0px_0px_14px_#0000000a]">
              <div className="flex flex-col lg:flex-row items-start lg:items-start gap-4 lg:gap-10 w-full h-auto ">
                {/* Icon */}
                <div className="hidden lg:block flex-shrink-0">
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-[100px] h-[100px]"
                  >
                    <path
                      d="M12.5 12.5V79.1667C12.5 81.3768 13.378 83.4964 14.9408 85.0592C16.5036 86.622 18.6232 87.5 20.8333 87.5H87.5"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M79.166 37.5L58.3327 58.3333L41.666 41.6667L29.166 54.1667"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {/* Text content */}
                <div className="flex flex-col w-full">
                  {/* Row for icon (mobile only) and title */}
                  <div className="flex flex-row items-center gap-2 lg:gap-4">
                    {/* Show icon only on mobile */}
                    <svg
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 lg:hidden"
                    >
                      <path
                        d="M12.5 12.5V79.1667C12.5 81.3768 13.378 83.4964 14.9408 85.0592C16.5036 86.622 18.6232 87.5 20.8333 87.5H87.5"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M79.166 37.5L58.3327 58.3333L41.666 41.6667L29.166 54.1667"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <p className="font-lora font-medium text-[#151515] text-sm lg:text-[22px] leading-5 lg:leading-[30px]">
                      Assured Earnings or Shared Profits
                    </p>
                  </div>

                  {/* Description */}
                  <p className="font-outfit font-[350] text-xs lg:text-[16px] leading-5 text-[#767676] text-left mt-2 lg:mt-4">
                    Whether you prefer a stable, fixed rental income or want to
                    maximize potential with a dynamic revenue-sharing model,
                    ZNORM offers flexibility to suit your property’s unique
                    profile and your financial goals.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col w-[362px] lg:w-[666px] h-[164px] lg:h-[746px]  items-center justify-center gap-4 p-6 relative bg-white rounded-[12px] border border-[#ebebeb] shadow-[0px_0px_14px_#0000000a]">
              <div className="flex flex-col lg:flex-row items-start lg:items-start gap-4 lg:gap-10 w-full h-auto">
                <div className="hidden lg:block flex-shrink-0">
                  <svg
                    viewBox="0 0 100 103"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-[100px] h-[100px]"
                  >
                    <g clip-path="url(#clip0_1934_54)">
                      <path
                        d="M77.8026 6.25421e-05C80.3829 -0.00791245 82.9075 0.746972 85.0564 2.16905C87.2054 3.59113 88.8819 5.6164 89.8737 7.9882C90.8655 10.36 91.1278 12.9716 90.6274 15.4919C90.127 18.0123 88.8864 20.3281 87.0629 22.1457C85.428 23.7773 83.3874 24.9473 81.1495 25.5364C78.9117 26.1255 76.5569 26.1124 74.3258 25.4986L73.5682 26.9236C75.0188 27.9179 76.3769 29.0401 77.6258 30.2764C83.0211 35.652 86.0518 42.9407 86.0518 50.5403C86.0518 58.14 83.0211 65.4286 77.6258 70.8042L77.0029 71.3993L82.0539 78.038C83.6154 77.3957 85.2893 77.0681 86.9787 77.074C88.6892 77.0724 90.3833 77.407 91.9637 78.0586C93.5441 78.7102 94.9798 79.666 96.1885 80.8712C97.4262 82.0694 98.4124 83.5005 99.09 85.0813C99.7676 86.6622 100.123 88.3614 100.135 90.0802C100.148 91.799 99.8174 93.5031 99.1629 95.0936C98.5085 96.6841 97.5432 98.1293 96.3231 99.3453C95.103 100.561 93.6524 101.524 92.0556 102.177C90.4588 102.83 88.7476 103.161 87.0214 103.15C85.2952 103.139 83.5883 102.786 82 102.113C80.4116 101.44 78.9735 100.459 77.769 99.2281C75.3499 96.8156 73.9801 93.5531 73.9549 90.1441C73.9297 86.7352 75.2512 83.453 77.6343 81.0053L72.7852 74.6684C69.6019 76.7025 66.047 78.0915 62.3239 78.756C58.6007 79.4205 54.7825 79.3473 51.0879 78.5407C47.3932 77.7341 43.8945 76.2099 40.7922 74.0553C37.6898 71.9008 35.0447 69.1581 33.0082 65.9844L24.413 70.4102C25.7844 72.8729 26.3133 75.7132 25.92 78.5018C25.5266 81.2904 24.2323 83.8757 22.2326 85.8669C19.7891 88.2972 16.4766 89.6624 13.0228 89.6624C9.56908 89.6624 6.25658 88.2972 3.81307 85.8669C1.37121 83.4311 -0.000227392 80.1301 -0.000227392 76.6885C-0.000227392 73.2468 1.37121 69.9458 3.81307 67.51L3.9646 67.3759C6.18377 65.2328 9.09666 63.9462 12.1817 63.7465C15.2667 63.5469 18.3223 64.4472 20.8015 66.2862C20.8807 66.2569 20.9624 66.2345 21.0456 66.2191L30.55 61.2988C28.8377 57.0926 28.1517 52.542 28.5483 48.0206C28.9449 43.4992 30.4128 39.136 32.8314 35.289L22.6451 27.4768H22.5946C20.143 29.8496 16.8518 31.1658 13.433 31.1407C10.0141 31.1156 6.74273 29.7512 4.32659 27.3427C2.99345 26.1693 1.91576 24.7365 1.15993 23.1326C0.40411 21.5288 -0.0138358 19.7878 -0.0681464 18.0169C-0.122457 16.2461 0.188018 14.4829 0.844146 12.8361C1.50027 11.1893 2.48815 9.69372 3.7469 8.44154C5.00565 7.18936 6.50861 6.20711 8.16315 5.55531C9.81768 4.90352 11.5887 4.596 13.3672 4.65169C15.1456 4.70739 16.8938 5.12513 18.5039 5.87917C20.1141 6.6332 21.552 7.70756 22.7293 9.03603C24.5408 10.8397 25.7791 13.1345 26.2896 15.6343C26.8 18.134 26.5602 20.728 25.6 23.0929C25.6908 23.1458 25.778 23.2046 25.8609 23.2689L36.0641 31.0895L36.9059 30.2513C41.0149 26.1653 46.2679 23.4107 51.9764 22.3488C57.6849 21.2868 63.5824 21.9669 68.8959 24.2999L69.5778 23.0175C69.2411 22.7493 68.9212 22.4559 68.6097 22.1793L68.475 22.0284C66.092 19.5874 64.77 16.3103 64.7952 12.9062C64.8205 9.50214 66.1908 6.24482 68.6097 3.83909C69.8132 2.62871 71.2447 1.66659 72.8221 1.00784C74.3996 0.349076 76.092 0.00661516 77.8026 6.25421e-05ZM58.2887 51.5168H56.1757C56.1482 51.5089 56.119 51.5089 56.0915 51.5168C56.0859 51.5301 56.0831 51.5444 56.0831 51.5587C56.0831 51.5731 56.0859 51.5874 56.0915 51.6007V56.0264C56.0835 56.0538 56.0835 56.0829 56.0915 56.1103C56.1048 56.1158 56.1191 56.1186 56.1336 56.1186C56.148 56.1186 56.1623 56.1158 56.1757 56.1103H58.2803C58.3075 56.1198 58.3372 56.1198 58.3645 56.1103C58.3735 56.083 58.3735 56.0537 58.3645 56.0264V51.6342C58.3748 51.6072 58.3748 51.5773 58.3645 51.5504C58.3526 51.545 58.3397 51.5423 58.3266 51.5423C58.3135 51.5423 58.3006 51.545 58.2887 51.5504V51.5168ZM44.6172 42.1288H51.916V40.0417C51.918 39.7443 52.0359 39.4593 52.2447 39.2466C52.4535 39.034 52.7371 38.9104 53.0356 38.9017H61.454C61.757 38.9039 62.0469 39.0247 62.2612 39.238C62.4754 39.4513 62.5967 39.74 62.5989 40.0417V42.1288H69.8725C70.3019 42.131 70.713 42.3024 71.0159 42.6056C71.3188 42.9087 71.4888 43.319 71.4888 43.7466V47.6359C69.7005 48.8654 67.8042 49.9315 65.8232 50.8211C63.8784 51.6857 61.8503 52.3513 59.7704 52.8077V51.2821C59.7715 51.1112 59.7385 50.9418 59.6733 50.7836C59.6081 50.6255 59.5121 50.4818 59.3907 50.361C59.2693 50.2401 59.125 50.1444 58.9662 50.0795C58.8074 50.0146 58.6372 49.9818 58.4655 49.9829H56.0242C55.8525 49.9818 55.6823 50.0146 55.5235 50.0795C55.3647 50.1444 55.2204 50.2401 55.099 50.361C54.9776 50.4818 54.8815 50.6255 54.8163 50.7836C54.7512 50.9418 54.7182 51.1112 54.7193 51.2821V52.8077C52.6942 52.3435 50.7203 51.6809 48.8264 50.8295C46.7913 49.9121 44.8442 48.8123 43.0093 47.5437V43.7466C43.0136 43.3217 43.1838 42.9152 43.484 42.6132C43.7841 42.3113 44.1906 42.1375 44.6172 42.1288ZM71.4972 49.9494V60.5193C71.499 60.7297 71.4581 60.9384 71.3771 61.1328C71.2961 61.3272 71.1767 61.5034 71.0258 61.6509C70.876 61.8017 70.6977 61.9216 70.5012 62.0036C70.3047 62.0856 70.0939 62.1281 69.8809 62.1287H44.6172C44.1891 62.1243 43.7796 61.9536 43.4761 61.653C43.1725 61.3523 42.999 60.9455 42.9924 60.5193V49.8488C44.5704 50.859 46.2222 51.7501 47.934 52.5143C50.1087 53.4962 52.3837 54.241 54.7193 54.7356V56.412C54.7193 56.7569 54.8554 57.088 55.0981 57.3341C55.2187 57.4539 55.3618 57.5488 55.5192 57.6136C55.6767 57.6783 55.8454 57.7115 56.0157 57.7112H58.4655C58.6372 57.7124 58.8074 57.6795 58.9662 57.6146C59.125 57.5497 59.2693 57.4541 59.3907 57.3332C59.5121 57.2123 59.6081 57.0687 59.6733 56.9105C59.7385 56.7524 59.7715 56.5829 59.7704 56.412V54.6601V54.7607C62.1519 54.2636 64.4721 53.5103 66.6903 52.5143C68.3452 51.7772 69.9434 50.9199 71.472 49.9494H71.4972ZM60.5533 40.4608H53.928C53.9124 40.4527 53.895 40.4485 53.8775 40.4485C53.8599 40.4485 53.8425 40.4527 53.8269 40.4608C53.8121 40.4732 53.8 40.4886 53.7913 40.5059C53.7826 40.5232 53.7776 40.542 53.7764 40.5613V42.045H60.6796V40.6033C60.6796 40.5655 60.6645 40.5292 60.6376 40.5025C60.6108 40.4758 60.5744 40.4608 60.5364 40.4608H60.5533ZM69.6788 29.8489C69.4617 29.7984 69.2522 29.7195 69.0559 29.6142C68.8255 29.4896 68.6131 29.3346 68.4245 29.1532C62.8872 26.2968 56.4437 25.7238 50.4857 27.5578C44.5276 29.3919 39.5332 33.4858 36.5811 38.9554C33.629 44.4251 32.9561 50.8314 34.7078 56.7908C36.4595 62.7503 40.4952 67.7845 45.9432 70.8062C51.3913 73.828 57.8144 74.5947 63.8254 72.9409C69.8364 71.287 74.9529 67.3453 78.0697 61.967C81.1865 56.5887 82.0536 50.2056 80.4836 44.1961C78.9136 38.1867 75.0326 33.0333 69.6788 29.8489ZM92.6864 84.333C91.188 82.8479 89.1656 82.0052 87.0515 81.9848C84.9374 81.9644 82.8991 82.7681 81.372 84.224L81.2626 84.3414C80.5122 85.0872 79.9169 85.9731 79.5107 86.9482C79.1046 87.9234 78.8955 88.9688 78.8955 90.0245C78.8955 91.0802 79.1046 92.1255 79.5107 93.1007C79.9169 94.0759 80.5122 94.9617 81.2626 95.7076C82.007 96.4767 82.8979 97.0903 83.8832 97.5127C84.8685 97.935 85.9284 98.1576 87.0011 98.1675C88.0738 98.1773 89.1377 97.9742 90.1307 97.5701C91.1236 97.1659 92.0257 96.5687 92.7843 95.8134C93.5428 95.0582 94.1426 94.1599 94.5485 93.1713C94.9545 92.1826 95.1584 91.1233 95.1485 90.0552C95.1386 88.9871 94.9151 87.9317 94.4909 86.9507C94.0667 85.9696 93.4504 85.0826 92.678 84.3414L92.6864 84.333ZM18.7474 71.0305C17.2489 69.5454 15.2266 68.7027 13.1125 68.6823C10.9983 68.6619 8.96001 69.4656 7.43299 70.9215L7.32355 71.0389C6.57317 71.7847 5.97785 72.6706 5.57167 73.6458C5.1655 74.6209 4.95642 75.6663 4.95642 76.722C4.95642 77.7777 5.1655 78.8231 5.57167 79.7982C5.97785 80.7734 6.57317 81.6592 7.32355 82.4051C8.07263 83.1523 8.96231 83.745 9.9417 84.1494C10.9211 84.5538 11.971 84.762 13.0312 84.762C14.0915 84.762 15.1414 84.5538 16.1208 84.1494C17.1002 83.745 17.9899 83.1523 18.7389 82.4051C20.2488 80.8941 21.0964 78.8493 21.0964 76.7178C21.0964 74.5863 20.2488 72.5415 18.7389 71.0305H18.7474ZM19.244 12.5146C17.7292 11.0074 15.675 10.1611 13.5334 10.1618C11.3918 10.1626 9.33822 11.0105 7.82445 12.5188C6.31067 14.0272 5.46069 16.0725 5.46148 18.2049C5.46227 20.3373 6.31377 22.382 7.82866 23.8892C9.32711 25.3743 11.3494 26.2171 13.4636 26.2374C15.5777 26.2578 17.616 25.4541 19.143 23.9982L19.2525 23.8808C20.7618 22.3712 21.6092 20.3278 21.6092 18.1977C21.6092 16.0676 20.7618 14.0242 19.2525 12.5146H19.244ZM83.5103 7.29254C82.7612 6.54539 81.8716 5.95264 80.8922 5.54821C79.9128 5.14378 78.8629 4.93561 77.8026 4.93561C76.7423 4.93561 75.6925 5.14378 74.7131 5.54821C73.7337 5.95264 72.844 6.54539 72.0949 7.29254C70.6026 8.78459 69.7563 10.7992 69.7374 12.9048C69.7186 15.0105 70.5285 17.0398 71.9939 18.5582L72.1034 18.6588C72.8524 19.4059 73.7421 19.9987 74.7215 20.4031C75.7009 20.8075 76.7508 21.0157 77.811 21.0157C78.8713 21.0157 79.9212 20.8075 80.9006 20.4031C81.88 19.9987 82.7697 19.4059 83.5187 18.6588C85.0306 17.1488 85.8796 15.1036 85.8796 12.9715C85.8796 10.8393 85.0306 8.79411 83.5187 7.28416L83.5103 7.29254Z"
                        fill="#94BB6D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1934_54">
                        <rect width="100" height="103" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="flex flex-col w-full">
                  {/* Row for icon (mobile only) and title */}
                  <div className="flex flex-row items-center gap-2 lg:gap-4">
                    {/* Show icon only on mobile */}
                    <svg
                      viewBox="0 0 100 103"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 lg:hidden"
                    >
                      <g clip-path="url(#clip0_1934_54)">
                        <path
                          d="M77.8026 6.25421e-05C80.3829 -0.00791245 82.9075 0.746972 85.0564 2.16905C87.2054 3.59113 88.8819 5.6164 89.8737 7.9882C90.8655 10.36 91.1278 12.9716 90.6274 15.4919C90.127 18.0123 88.8864 20.3281 87.0629 22.1457C85.428 23.7773 83.3874 24.9473 81.1495 25.5364C78.9117 26.1255 76.5569 26.1124 74.3258 25.4986L73.5682 26.9236C75.0188 27.9179 76.3769 29.0401 77.6258 30.2764C83.0211 35.652 86.0518 42.9407 86.0518 50.5403C86.0518 58.14 83.0211 65.4286 77.6258 70.8042L77.0029 71.3993L82.0539 78.038C83.6154 77.3957 85.2893 77.0681 86.9787 77.074C88.6892 77.0724 90.3833 77.407 91.9637 78.0586C93.5441 78.7102 94.9798 79.666 96.1885 80.8712C97.4262 82.0694 98.4124 83.5005 99.09 85.0813C99.7676 86.6622 100.123 88.3614 100.135 90.0802C100.148 91.799 99.8174 93.5031 99.1629 95.0936C98.5085 96.6841 97.5432 98.1293 96.3231 99.3453C95.103 100.561 93.6524 101.524 92.0556 102.177C90.4588 102.83 88.7476 103.161 87.0214 103.15C85.2952 103.139 83.5883 102.786 82 102.113C80.4116 101.44 78.9735 100.459 77.769 99.2281C75.3499 96.8156 73.9801 93.5531 73.9549 90.1441C73.9297 86.7352 75.2512 83.453 77.6343 81.0053L72.7852 74.6684C69.6019 76.7025 66.047 78.0915 62.3239 78.756C58.6007 79.4205 54.7825 79.3473 51.0879 78.5407C47.3932 77.7341 43.8945 76.2099 40.7922 74.0553C37.6898 71.9008 35.0447 69.1581 33.0082 65.9844L24.413 70.4102C25.7844 72.8729 26.3133 75.7132 25.92 78.5018C25.5266 81.2904 24.2323 83.8757 22.2326 85.8669C19.7891 88.2972 16.4766 89.6624 13.0228 89.6624C9.56908 89.6624 6.25658 88.2972 3.81307 85.8669C1.37121 83.4311 -0.000227392 80.1301 -0.000227392 76.6885C-0.000227392 73.2468 1.37121 69.9458 3.81307 67.51L3.9646 67.3759C6.18377 65.2328 9.09666 63.9462 12.1817 63.7465C15.2667 63.5469 18.3223 64.4472 20.8015 66.2862C20.8807 66.2569 20.9624 66.2345 21.0456 66.2191L30.55 61.2988C28.8377 57.0926 28.1517 52.542 28.5483 48.0206C28.9449 43.4992 30.4128 39.136 32.8314 35.289L22.6451 27.4768H22.5946C20.143 29.8496 16.8518 31.1658 13.433 31.1407C10.0141 31.1156 6.74273 29.7512 4.32659 27.3427C2.99345 26.1693 1.91576 24.7365 1.15993 23.1326C0.40411 21.5288 -0.0138358 19.7878 -0.0681464 18.0169C-0.122457 16.2461 0.188018 14.4829 0.844146 12.8361C1.50027 11.1893 2.48815 9.69372 3.7469 8.44154C5.00565 7.18936 6.50861 6.20711 8.16315 5.55531C9.81768 4.90352 11.5887 4.596 13.3672 4.65169C15.1456 4.70739 16.8938 5.12513 18.5039 5.87917C20.1141 6.6332 21.552 7.70756 22.7293 9.03603C24.5408 10.8397 25.7791 13.1345 26.2896 15.6343C26.8 18.134 26.5602 20.728 25.6 23.0929C25.6908 23.1458 25.778 23.2046 25.8609 23.2689L36.0641 31.0895L36.9059 30.2513C41.0149 26.1653 46.2679 23.4107 51.9764 22.3488C57.6849 21.2868 63.5824 21.9669 68.8959 24.2999L69.5778 23.0175C69.2411 22.7493 68.9212 22.4559 68.6097 22.1793L68.475 22.0284C66.092 19.5874 64.77 16.3103 64.7952 12.9062C64.8205 9.50214 66.1908 6.24482 68.6097 3.83909C69.8132 2.62871 71.2447 1.66659 72.8221 1.00784C74.3996 0.349076 76.092 0.00661516 77.8026 6.25421e-05ZM58.2887 51.5168H56.1757C56.1482 51.5089 56.119 51.5089 56.0915 51.5168C56.0859 51.5301 56.0831 51.5444 56.0831 51.5587C56.0831 51.5731 56.0859 51.5874 56.0915 51.6007V56.0264C56.0835 56.0538 56.0835 56.0829 56.0915 56.1103C56.1048 56.1158 56.1191 56.1186 56.1336 56.1186C56.148 56.1186 56.1623 56.1158 56.1757 56.1103H58.2803C58.3075 56.1198 58.3372 56.1198 58.3645 56.1103C58.3735 56.083 58.3735 56.0537 58.3645 56.0264V51.6342C58.3748 51.6072 58.3748 51.5773 58.3645 51.5504C58.3526 51.545 58.3397 51.5423 58.3266 51.5423C58.3135 51.5423 58.3006 51.545 58.2887 51.5504V51.5168ZM44.6172 42.1288H51.916V40.0417C51.918 39.7443 52.0359 39.4593 52.2447 39.2466C52.4535 39.034 52.7371 38.9104 53.0356 38.9017H61.454C61.757 38.9039 62.0469 39.0247 62.2612 39.238C62.4754 39.4513 62.5967 39.74 62.5989 40.0417V42.1288H69.8725C70.3019 42.131 70.713 42.3024 71.0159 42.6056C71.3188 42.9087 71.4888 43.319 71.4888 43.7466V47.6359C69.7005 48.8654 67.8042 49.9315 65.8232 50.8211C63.8784 51.6857 61.8503 52.3513 59.7704 52.8077V51.2821C59.7715 51.1112 59.7385 50.9418 59.6733 50.7836C59.6081 50.6255 59.5121 50.4818 59.3907 50.361C59.2693 50.2401 59.125 50.1444 58.9662 50.0795C58.8074 50.0146 58.6372 49.9818 58.4655 49.9829H56.0242C55.8525 49.9818 55.6823 50.0146 55.5235 50.0795C55.3647 50.1444 55.2204 50.2401 55.099 50.361C54.9776 50.4818 54.8815 50.6255 54.8163 50.7836C54.7512 50.9418 54.7182 51.1112 54.7193 51.2821V52.8077C52.6942 52.3435 50.7203 51.6809 48.8264 50.8295C46.7913 49.9121 44.8442 48.8123 43.0093 47.5437V43.7466C43.0136 43.3217 43.1838 42.9152 43.484 42.6132C43.7841 42.3113 44.1906 42.1375 44.6172 42.1288ZM71.4972 49.9494V60.5193C71.499 60.7297 71.4581 60.9384 71.3771 61.1328C71.2961 61.3272 71.1767 61.5034 71.0258 61.6509C70.876 61.8017 70.6977 61.9216 70.5012 62.0036C70.3047 62.0856 70.0939 62.1281 69.8809 62.1287H44.6172C44.1891 62.1243 43.7796 61.9536 43.4761 61.653C43.1725 61.3523 42.999 60.9455 42.9924 60.5193V49.8488C44.5704 50.859 46.2222 51.7501 47.934 52.5143C50.1087 53.4962 52.3837 54.241 54.7193 54.7356V56.412C54.7193 56.7569 54.8554 57.088 55.0981 57.3341C55.2187 57.4539 55.3618 57.5488 55.5192 57.6136C55.6767 57.6783 55.8454 57.7115 56.0157 57.7112H58.4655C58.6372 57.7124 58.8074 57.6795 58.9662 57.6146C59.125 57.5497 59.2693 57.4541 59.3907 57.3332C59.5121 57.2123 59.6081 57.0687 59.6733 56.9105C59.7385 56.7524 59.7715 56.5829 59.7704 56.412V54.6601V54.7607C62.1519 54.2636 64.4721 53.5103 66.6903 52.5143C68.3452 51.7772 69.9434 50.9199 71.472 49.9494H71.4972ZM60.5533 40.4608H53.928C53.9124 40.4527 53.895 40.4485 53.8775 40.4485C53.8599 40.4485 53.8425 40.4527 53.8269 40.4608C53.8121 40.4732 53.8 40.4886 53.7913 40.5059C53.7826 40.5232 53.7776 40.542 53.7764 40.5613V42.045H60.6796V40.6033C60.6796 40.5655 60.6645 40.5292 60.6376 40.5025C60.6108 40.4758 60.5744 40.4608 60.5364 40.4608H60.5533ZM69.6788 29.8489C69.4617 29.7984 69.2522 29.7195 69.0559 29.6142C68.8255 29.4896 68.6131 29.3346 68.4245 29.1532C62.8872 26.2968 56.4437 25.7238 50.4857 27.5578C44.5276 29.3919 39.5332 33.4858 36.5811 38.9554C33.629 44.4251 32.9561 50.8314 34.7078 56.7908C36.4595 62.7503 40.4952 67.7845 45.9432 70.8062C51.3913 73.828 57.8144 74.5947 63.8254 72.9409C69.8364 71.287 74.9529 67.3453 78.0697 61.967C81.1865 56.5887 82.0536 50.2056 80.4836 44.1961C78.9136 38.1867 75.0326 33.0333 69.6788 29.8489ZM92.6864 84.333C91.188 82.8479 89.1656 82.0052 87.0515 81.9848C84.9374 81.9644 82.8991 82.7681 81.372 84.224L81.2626 84.3414C80.5122 85.0872 79.9169 85.9731 79.5107 86.9482C79.1046 87.9234 78.8955 88.9688 78.8955 90.0245C78.8955 91.0802 79.1046 92.1255 79.5107 93.1007C79.9169 94.0759 80.5122 94.9617 81.2626 95.7076C82.007 96.4767 82.8979 97.0903 83.8832 97.5127C84.8685 97.935 85.9284 98.1576 87.0011 98.1675C88.0738 98.1773 89.1377 97.9742 90.1307 97.5701C91.1236 97.1659 92.0257 96.5687 92.7843 95.8134C93.5428 95.0582 94.1426 94.1599 94.5485 93.1713C94.9545 92.1826 95.1584 91.1233 95.1485 90.0552C95.1386 88.9871 94.9151 87.9317 94.4909 86.9507C94.0667 85.9696 93.4504 85.0826 92.678 84.3414L92.6864 84.333ZM18.7474 71.0305C17.2489 69.5454 15.2266 68.7027 13.1125 68.6823C10.9983 68.6619 8.96001 69.4656 7.43299 70.9215L7.32355 71.0389C6.57317 71.7847 5.97785 72.6706 5.57167 73.6458C5.1655 74.6209 4.95642 75.6663 4.95642 76.722C4.95642 77.7777 5.1655 78.8231 5.57167 79.7982C5.97785 80.7734 6.57317 81.6592 7.32355 82.4051C8.07263 83.1523 8.96231 83.745 9.9417 84.1494C10.9211 84.5538 11.971 84.762 13.0312 84.762C14.0915 84.762 15.1414 84.5538 16.1208 84.1494C17.1002 83.745 17.9899 83.1523 18.7389 82.4051C20.2488 80.8941 21.0964 78.8493 21.0964 76.7178C21.0964 74.5863 20.2488 72.5415 18.7389 71.0305H18.7474ZM19.244 12.5146C17.7292 11.0074 15.675 10.1611 13.5334 10.1618C11.3918 10.1626 9.33822 11.0105 7.82445 12.5188C6.31067 14.0272 5.46069 16.0725 5.46148 18.2049C5.46227 20.3373 6.31377 22.382 7.82866 23.8892C9.32711 25.3743 11.3494 26.2171 13.4636 26.2374C15.5777 26.2578 17.616 25.4541 19.143 23.9982L19.2525 23.8808C20.7618 22.3712 21.6092 20.3278 21.6092 18.1977C21.6092 16.0676 20.7618 14.0242 19.2525 12.5146H19.244ZM83.5103 7.29254C82.7612 6.54539 81.8716 5.95264 80.8922 5.54821C79.9128 5.14378 78.8629 4.93561 77.8026 4.93561C76.7423 4.93561 75.6925 5.14378 74.7131 5.54821C73.7337 5.95264 72.844 6.54539 72.0949 7.29254C70.6026 8.78459 69.7563 10.7992 69.7374 12.9048C69.7186 15.0105 70.5285 17.0398 71.9939 18.5582L72.1034 18.6588C72.8524 19.4059 73.7421 19.9987 74.7215 20.4031C75.7009 20.8075 76.7508 21.0157 77.811 21.0157C78.8713 21.0157 79.9212 20.8075 80.9006 20.4031C81.88 19.9987 82.7697 19.4059 83.5187 18.6588C85.0306 17.1488 85.8796 15.1036 85.8796 12.9715C85.8796 10.8393 85.0306 8.79411 83.5187 7.28416L83.5103 7.29254Z"
                          fill="#94BB6D"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1934_54">
                          <rect width="100" height="103" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <p className="font-lora font-medium text-[#151515] text-sm lg:text-[22px] leading-5 lg:leading-[30px]">
                      Full-Service Management
                    </p>
                  </div>

                  {/* Description */}
                  <p className="font-outfit font-[350] text-xs lg:text-[16px] leading-5 text-[#767676] text-left mt-2 lg:mt-4">
                    Sit back while we take care of everything - from designing
                    interiors & professional marketing to seamless guest
                    coordination, 24/7 support, housekeeping, & maintenance -
                    all under one roof.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col w-[362px] lg:w-[666px] h-[164px] lg:h-[746px] items-center justify-center gap-4 p-6 relative bg-white rounded-[12px] border border-[#ebebeb] shadow-[0px_0px_14px_#0000000a]">
              <div className="flex flex-col lg:flex-row items-start gap-4 lg:gap-10 w-full h-auto">
                {/* Icon (only visible on desktop) */}
                <div className="hidden lg:block flex-shrink-0">
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-[100px] h-[100px]"
                  >
                    <path
                      d="M25 91.6667V16.6667C25 14.4565 25.878 12.3369 27.4408 10.7741C29.0036 9.2113 31.1232 8.33333 33.3333 8.33333H66.6667C68.8768 8.33333 70.9964 9.2113 72.5592 10.7741C74.122 12.3369 75 14.4565 75 16.6667V91.6667H25Z"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M25.0007 50H16.6673C14.4572 50 12.3376 50.878 10.7748 52.4408C9.21196 54.0036 8.33398 56.1232 8.33398 58.3333V83.3333C8.33398 85.5435 9.21196 87.6631 10.7748 89.2259C12.3376 90.7887 14.4572 91.6667 16.6673 91.6667H25.0007"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M75 37.5H83.3333C85.5435 37.5 87.6631 38.378 89.2259 39.9408C90.7887 41.5036 91.6667 43.6232 91.6667 45.8333V83.3333C91.6667 85.5435 90.7887 87.6631 89.2259 89.2259C87.6631 90.7887 85.5435 91.6667 83.3333 91.6667H75"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M41.666 25H58.3327"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M41.666 41.6667H58.3327"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M41.666 58.3333H58.3327"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M41.666 75H58.3327"
                      stroke="#94BB6D"
                      strokeWidth="6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {/* Content */}
                <div className="flex flex-col w-full">
                  <div className="flex flex-row items-center gap-2 lg:gap-4">
                    {/* Icon (mobile only) */}
                    <svg
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 lg:hidden"
                    >
                      <path
                        d="M25 91.6667V16.6667C25 14.4565 25.878 12.3369 27.4408 10.7741C29.0036 9.2113 31.1232 8.33333 33.3333 8.33333H66.6667C68.8768 8.33333 70.9964 9.2113 72.5592 10.7741C74.122 12.3369 75 14.4565 75 16.6667V91.6667H25Z"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M25.0007 50H16.6673C14.4572 50 12.3376 50.878 10.7748 52.4408C9.21196 54.0036 8.33398 56.1232 8.33398 58.3333V83.3333C8.33398 85.5435 9.21196 87.6631 10.7748 89.2259C12.3376 90.7887 14.4572 91.6667 16.6673 91.6667H25.0007"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M75 37.5H83.3333C85.5435 37.5 87.6631 38.378 89.2259 39.9408C90.7887 41.5036 91.6667 43.6232 91.6667 45.8333V83.3333C91.6667 85.5435 90.7887 87.6631 89.2259 89.2259C87.6631 90.7887 85.5435 91.6667 83.3333 91.6667H75"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M41.666 25H58.3327"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M41.666 41.6667H58.3327"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M41.666 58.3333H58.3327"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M41.666 75H58.3327"
                        stroke="#94BB6D"
                        strokeWidth="6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    {/* Heading */}
                    <p className="font-lora font-medium text-[#151515] text-sm lg:text-[22px] leading-5 lg:leading-[30px]">
                      Privileges for Owners
                    </p>
                  </div>

                  {/* Description */}
                  <p className="font-outfit font-[350] text-xs lg:text-[16px] leading-5 text-[#767676] text-left mt-2 lg:mt-4">
                    Need your property for personal use? Simply block your
                    calendar in advance. With just 30 days’ notice, you can
                    enjoy your space anytime without restrictions or
                    interruptions.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col w-[362px] lg:w-[666px] h-[164px] lg:h-[746px]  items-center justify-center gap-4 p-6 relative bg-white rounded-[12px] border border-[#ebebeb] shadow-[0px_0px_14px_#0000000a]">
              <div className="flex flex-col lg:flex-row items-start lg:items-start gap-4 lg:gap-10 w-full h-auto">
                {/* Icon (only visible on desktop) */}

                <div className="hidden lg:block flex-shrink-0">
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-[100px] h-[100px]"
                  >
                    <path
                      d="M45.834 70.8333L54.1673 79.1667C54.9881 79.9874 55.9625 80.6385 57.0348 81.0827C58.1072 81.5269 59.2566 81.7555 60.4173 81.7555C61.5781 81.7555 62.7274 81.5269 63.7998 81.0827C64.8722 80.6385 65.8466 79.9874 66.6673 79.1667C67.4881 78.3459 68.1391 77.3715 68.5833 76.2991C69.0275 75.2268 69.2562 74.0774 69.2562 72.9167C69.2562 71.7559 69.0275 70.6066 68.5833 69.5342C68.1391 68.4618 67.4881 67.4874 66.6673 66.6667"
                      stroke="#94BB6D"
                      stroke-width="6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M58.3343 58.3333L68.7509 68.75C70.4085 70.4076 72.6567 71.3388 75.0009 71.3388C77.3451 71.3388 79.5933 70.4076 81.2509 68.75C82.9085 67.0924 83.8398 64.8442 83.8398 62.5C83.8398 60.1558 82.9085 57.9076 81.2509 56.25L65.0843 40.0833C62.7405 37.7425 59.5635 36.4277 56.2509 36.4277C52.9384 36.4277 49.7614 37.7425 47.4176 40.0833L43.7509 43.75C42.0933 45.4076 39.8451 46.3388 37.5009 46.3388C35.1567 46.3388 32.9085 45.4076 31.2509 43.75C29.5933 42.0924 28.6621 39.8442 28.6621 37.5C28.6621 35.1558 29.5933 32.9076 31.2509 31.25L42.9593 19.5417C46.7603 15.7506 51.7172 13.3356 57.0453 12.6791C62.3734 12.0225 67.7683 13.1618 72.3759 15.9167L74.3343 17.0833C76.1084 18.1541 78.2178 18.5255 80.2509 18.125L87.5009 16.6667"
                      stroke="#94BB6D"
                      stroke-width="6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M87.5007 12.5L91.6673 58.3333H83.334"
                      stroke="#94BB6D"
                      stroke-width="6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5007 12.5L8.33398 58.3333L35.4173 85.4167C37.0749 87.0743 39.3231 88.0055 41.6673 88.0055C44.0115 88.0055 46.2597 87.0743 47.9173 85.4167C49.5749 83.7591 50.5062 81.5109 50.5062 79.1667C50.5062 76.8225 49.5749 74.5743 47.9173 72.9167"
                      stroke="#94BB6D"
                      stroke-width="6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 16.6667H45.8333"
                      stroke="#94BB6D"
                      stroke-width="6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <div className="flex flex-col w-full">
                  {/* Row for icon (mobile only) and title */}
                  <div className="flex flex-row items-center gap-2 lg:gap-4">
                    {/* Show icon only on mobile */}
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="block lg:hidden"
                    >
                      <path
                        d="M11 17L13 19C13.197 19.197 13.4308 19.3532 13.6882 19.4598C13.9456 19.5665 14.2214 19.6213 14.5 19.6213C14.7786 19.6213 15.0544 19.5665 15.3118 19.4598C15.5692 19.3532 15.803 19.197 16 19C16.197 18.803 16.3532 18.5692 16.4598 18.3118C16.5665 18.0544 16.6213 17.7786 16.6213 17.5C16.6213 17.2214 16.5665 16.9456 16.4598 16.6882C16.3532 16.4308 16.197 16.197 16 16"
                        stroke="#94BB6D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.0002 14L16.5002 16.5C16.8981 16.8978 17.4376 17.1213 18.0002 17.1213C18.5628 17.1213 19.1024 16.8978 19.5002 16.5C19.8981 16.1022 20.1215 15.5626 20.1215 15C20.1215 14.4374 19.8981 13.8978 19.5002 13.5L15.6202 9.62002C15.0577 9.05821 14.2952 8.74265 13.5002 8.74265C12.7052 8.74265 11.9427 9.05821 11.3802 9.62002L10.5002 10.5C10.1024 10.8978 9.56284 11.1213 9.00023 11.1213C8.43762 11.1213 7.89805 10.8978 7.50023 10.5C7.1024 10.1022 6.87891 9.56262 6.87891 9.00002C6.87891 8.43741 7.1024 7.89784 7.50023 7.50002L10.3102 4.69002C11.2225 3.78016 12.4121 3.20057 13.6909 3.04299C14.9696 2.88541 16.2644 3.15885 17.3702 3.82002L17.8402 4.10002C18.266 4.357 18.7723 4.44613 19.2602 4.35002L21.0002 4.00002"
                        stroke="#94BB6D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 3L22 14H20"
                        stroke="#94BB6D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3 3L2 14L8.5 20.5C8.89782 20.8978 9.43739 21.1213 10 21.1213C10.5626 21.1213 11.1022 20.8978 11.5 20.5C11.8978 20.1022 12.1213 19.5626 12.1213 19C12.1213 18.4374 11.8978 17.8978 11.5 17.5"
                        stroke="#94BB6D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3 4H11"
                        stroke="#94BB6D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p className="font-lora font-medium text-[#151515] text-sm lg:text-[22px] leading-5 lg:leading-[30px]">
                      Transparent Financials
                    </p>
                  </div>

                  {/* Description */}
                  <p className="font-outfit font-[350] text-xs lg:text-[16px] leading-5 text-[#767676] text-left mt-2 lg:mt-4">
                    Stay informed with clear, comprehensive monthly financial
                    reports that detail your income, booking rates, and all
                    operational expenses — no hidden fees or surprises.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hidden lg:flex w-full  flex-col justify-center items-center  h-auto px-[16px] lg:px-[106px] py-[120px] lg:p-[55px] xl:p-[150px] gap-[80px] lg:gap-36 xl:gap-40 bg-white lg:mt-[200px]">
        <h2 className=" lg:w-[1300px] lg:h-[40px] font-lora font-medium lg:text-[38px]  lg:leading-[40px] tracking-[0px] text-center text-[#151515] mx-auto mb-[96px]">
          Tailored Partnership Options
        </h2>
        <div className="lg:w-[1300px] lg:h-[412px] lg:flex flex-row lg:justify-between gap-[80px]   ">
          <div className="flex flex-col justify-center items-center lg:w-[628px] lg:h-[412px]  ">
            <motion.div
              className="relative lg:w-[596px] lg:h-[380px] rounded-[12px] bg-[#DBE0CE] "
              {...slideInFromBottom}
            >
              <motion.img
                src="/images/Partnership/image2.webp"
                alt="Revenue-based partnership"
                className=" top-[32px] left-[32px] lg:w-[596px] lg:h-[384px] lg:rounded-[14px] shadow-[inset_0px_0px_12px_0px_#00000014] object-cover absolute"
                {...slideInFromBottom}
              />
            </motion.div>
          </div>

          <div className="lg:w-[579px] lg:h-[332px] lg:gap-[32px] flex flex-col items-start relative">
            <div className="lg:w-[579px] lg:h-[31px] font-lora font-medium lg:text-[24px] lg:leading-[100%] lg:tracking-[0px] lg:text-[#151515] mt-[40px]">
              Revenue Share Model
            </div>

            <div className="flex flex-col lg:w-[580px] lg:h-[268px] items-start gap-6 relative ">
              <p className="lg:w-[558px] lg:h-[72px] font-outfit font-[350] lg:text-[16px] lg:leading-[24px] lg:tracking-[0px] lg:text-[#2D2D2D]">
                Maximize your rental income without the hassle. With ZNORM
                Homes' Revenue Share Model, you earn more as your property
                performs better. We take care of guest hosting, dynamic pricing,
                marketing, and maintenance—while you enjoy:
              </p>

              <div className="lg:w-[580px] lg:h-[100px] lg:gap-[14px] flex flex-col items-start relative ">
                {[
                  "A transparent revenue-sharing agreement",
                  "Full visibility through detailed monthly reports.",
                  "Flexibility to block dates for personal stays.",
                ].map((text, idx) => (
                  <div
                    key={idx}
                    className="lg:w-[580px] lg:h-[24px] lg:gap-[16px] flex items-center   relative "
                  >
                    <div className="w-[16px] h-[16px] bg-[#E3F1D6] rounded-[30px] flex items-center justify-center">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.33268 2.5L3.74935 7.08333L1.66602 5"
                          stroke="#4CAF50"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <p className="text-[#2d2d2d] text-base leading-6 whitespace-nowrap font-outfit font-[350]">
                      {text}
                    </p>
                  </div>
                ))}
              </div>

              <p className="lg:w-[558px] lg:h-[48px] font-outfit text-[#2d2d2d] text-base leading-6 font-[350]">
                Ideal for homeowners looking to earn high returns while keeping
                control and involvement.
              </p>
            </div>
          </div>
        </div>
        <div className="lg:w-[1300px] lg:h-[412px] lg:flex flex-row lg:justify-between     ">
          <div className="flex flex-col justify-center items-center lg:w-[628px] lg:h-[412px]  ">
            <div className="lg:w-[579px] lg:h-[31px] font-lora font-medium lg:text-[24px] lg:leading-[100%] lg:tracking-[0px] lg:text-[#151515] mt-[40px]">
              Assured-Rental Model
            </div>

            <div className="flex flex-col lg:w-[580px] lg:h-[268px] items-start gap-6 relative ">
              <p className="lg:w-[558px] lg:h-[72px] font-outfit font-[350] lg:text-[16px] lg:leading-[24px] lg:tracking-[0px] lg:text-[#2D2D2D]">
                Prefer a fixed, worry-free income, guaranteed monthly rent,
                5–10% higher than market average? Our Assured Rental Model
                offers:
              </p>

              <div className="lg:w-[580px] lg:h-[100px] lg:gap-[14px] flex flex-col items-start relative ">
                {[
                  "Zero vacancy risk, paid on time every month.",
                  "Full property management, including cleaning and upkeep.",
                  "Easy exit with advance notice.",
                ].map((text, idx) => (
                  <div
                    key={idx}
                    className="lg:w-[580px] lg:h-[24px] lg:gap-[16px] flex items-center   relative "
                  >
                    <div className="w-[16px] h-[16px] bg-[#E3F1D6] rounded-[30px] flex items-center justify-center">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.33268 2.5L3.74935 7.08333L1.66602 5"
                          stroke="#4CAF50"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <p className="text-[#2d2d2d] text-base leading-6 whitespace-nowrap font-outfit font-[350]">
                      {text}
                    </p>
                  </div>
                ))}
              </div>

              <p className="lg:w-[558px] lg:h-[48px] font-outfit text-[#2d2d2d] text-base leading-6 font-[350]">
                Perfect for investors and second-home owners seeking passive
                income with no day-to-day involvement.
              </p>
            </div>
          </div>

          <div className="relative lg:w-[628px] lg:h-[412px] flex flex-col items-start">
            <motion.div
              className="absolute top-0 right-0 w-[596px] h-[380px] bg-[#DBE0CE] rounded-[14px] z-0"
              style={{
                boxShadow: "inset 0px 0px 12px 0px #00000014",
              }}
              {...slideInFromBottom}
            />
            <motion.img
              src="/images/Partnership/image3.webp"
              alt="Assured Rental model"
              className="absolute bottom-0 left-0 w-[596px] h-[380px] rounded-[14px] object-cover z-10"
              {...slideInFromBottom}
            />
          </div>
        </div>
      </section>



      {/* Tailored Partnership Options - Mobile View */}
      <section className="lg:hidden px-4 pt-[120px] w-full flex flex-col items-center">
        <div className="px-[37px] mb-[48px]">
          <h2 className="font-lora text-[18px] leading-[26px] font-medium text-[#151515] text-center">
            Tailored Partnership Options
          </h2>
        </div>
        <motion.div
          className="w-full h-[555px]  space-y-[24px] "
          {...slideInFromBottom}
        >
          <div className="font-lora text-[14px] leading-[18px]  text-[#151515] mt-[24px]">
            Revenue Share Model
          </div>
          <p className="font-outfit text-[12px] leading-[20px] text-[#2D2D2D]">
            Maximize your rental income without the hassle. With ZNORM Homes' Revenue Share Model,
            you earn more as your property performs better. We take care of guest hosting, dynamic pricing,
            marketing, and maintenance—while you enjoy:
          </p>

          <ul className="flex flex-col gap-[8px]">
            {[
              "A transparent revenue-sharing agreement",
              "Full visibility through detailed monthly reports.",
              "Flexibility to block dates for personal stays.",
            ].map((item, idx) => (
              <li key={idx} className="flex items-start gap-[10px]">
                <div className="w-[16px] h-[16px] bg-[#E3F1D6] rounded-full flex items-center justify-center mt-[2px]">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.33268 2.5L3.74935 7.08333L1.66602 5"
                      stroke="#4CAF50"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span className="font-outfit text-[12px] text-[#2D2D2D] leading-[18px]">{item}</span>
              </li>
            ))}
          </ul>

          <p className="font-outfit text-[12px] leading-[20px] text-[#2D2D2D]">
            Ideal for homeowners looking to earn high returns while keeping control and involvement.
          </p>

          <div className="flex justify-center w-[361px] h-[237px] mt-[40px]">
            <motion.div
              className="relative w-[342px] h-[218px] rounded-[12px] bg-[#DBE0CE] shadow-[inset_0px_0px_12px_0px_#00000014]"
              {...slideInFromBottom}
            >
              <motion.img
                src="/images/Partnership/image2.webp"
                alt="Revenue-Based Partnership"
                className="absolute top-[18px] left-[18px] w-[342px] h-[218px] rounded-[14px] object-cover"
                {...slideInFromBottom}
              />
            </motion.div>

          </div>
        </motion.div>
        <motion.div
          className="flex flex-col items-start text-left justify-center mt-[64px] gap-[24px]"
          {...slideInFromBottom}
        >
          <div className="font-lora text-[14px] text-[#151515] leading-[18px]">
            Assured-Rental Model
          </div>
          <p className="font-outfit text-[12px] leading-[20px] text-[#2D2D2D]">
            Prefer a fixed, worry-free income, guaranteed monthly rent, 5–10% higher than market average?
            Our Assured Rental Model offers:
          </p>

          <ul className="flex flex-col gap-[8px]">
            {[
              "Zero vacancy risk, paid on time every month.",
              "Full property management, including cleaning and upkeep.",
              "Easy exit with advance notice.",
            ].map((item, idx) => (
              <li key={idx} className="flex items-start gap-[10px]">
                <div className="w-[16px] h-[16px] bg-[#E3F1D6] rounded-full flex items-center justify-center mt-[2px]">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.33268 2.5L3.74935 7.08333L1.66602 5"
                      stroke="#4CAF50"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span className="font-outfit text-[12px] text-[#2D2D2D] leading-[18px]">{item}</span>
              </li>
            ))}
          </ul>

          <p className="font-outfit text-[12px] leading-[20px] text-[#2D2D2D]">
            Perfect for investors and second-home owners seeking passive income with no day-to-day involvement.
          </p>

          <div className="flex justify-center w-[361px] h-[237px] mt-[40px] relative">
  {/* Green background shifted right */}
  <motion.div
    className="absolute top-0 right-0 w-[342px] h-[218px] rounded-[12px] bg-[#DBE0CE] shadow-[inset_0px_0px_12px_0px_#00000014] z-0  "
    {...slideInFromBottom}
  />

  {/* Image on top */}
  <motion.img
    src="/images/Partnership/image3.webp"
    alt="Assured Rental Model"
    className="absolute bottom-0 left-0 w-[342px] h-[218px] rounded-[14px] object-cover z-10"
    {...slideInFromBottom}
  />
</div>

        </motion.div>
      </section>


      <section className="flex flex-col justify-center items-center text-center w-full lg:pt-[200px] pt-[120px]">
        <div className="lg:px-[106px] px-[114px]">
          <motion.div className="text-[#151515]" {...slideInFromBottom}>
            <h1 className=" font-lora font-medium lg:text-[38px] text-[18px] leading-[26px] lg:leading-[100%] tracking-[0px] text-center">
              How to Get Started
            </h1>
          </motion.div>

          <motion.div
            className="w-full max-w-[1300px] lg:mt-[96px] mt-[48px] lg:px-[98px] flex flex-col lg:flex-row  gap-10  lg:gap-[124px] justify-center items-center"
            {...slideInFromBottom}
          >
            <div className=" lg:w-[285px] lg:h-[179px] w-[285px] h-[158px] flex flex-col items-center text-center ">
              <div className="w-[64px] h-[64px] rounded-full bg-[#E5F8D2] flex items-center justify-center text-[#94BB6D]">
                <h1 className="w-[29px] h-[32px] font-outfit font-medium text-[28px] leading-[32px] tracking-[0px]">
                  01
                </h1>
              </div>
              <h2 className="w-[285px] lg:h-[31px] font-lora font-medium lg:text-[24px]  text-[14px]  leading-[18px] lg:leading-[100%] tracking-[0px] text-[#000000] mt-6">
                Schedule a Property Visit
              </h2>
              <p className="w-[269px] h-[48px] font-outfit font-[350] lg:text-[16px] text-[12px] lg:leading-[24px] leading-[20px] tracking-[0px] text-[#767676] text-center mt-2">
                Our experts evaluate your space and recommend the best model.
              </p>
            </div>
            <div className=" lg:w-[285px] lg:h-[179px] flex flex-col items-center text-center  ">
              <div className="w-[64px] h-[64px] rounded-full bg-[#E5F8D2] flex items-center justify-center text-[#94BB6D]">
                <h1 className="lg:w-[34px] lg:h-[32px]  font-outfit font-medium text-[28px] leading-[32px] tracking-[0px]">
                  02
                </h1>
              </div>
              <h2 className="font-lora font-medium lg:text-[24px] lg:leading-[100%]  text-[14px]  leading-[18px] tracking-[0px] text-[#000000] mt-6">
                Sign the Agreement
              </h2>
              <p className="w-[285px] h-[48px] font-outfit font-[350] lg:text-[16px] text-[12px] lg:leading-[24px] leading-[20px] tracking-[0px] text-[#767676] text-center mt-3">
                We finalize terms, initiate onboarding, and list your property.
              </p>
            </div>
            <div className=" lg:w-[285px] lg:h-[179px] flex flex-col items-center text-center ">
              <div className="w-[64px] h-[64px] rounded-full bg-[#E5F8D2] flex items-center justify-center text-[#94BB6D]">
                <h1 className="w-[34px] h-[32px] font-outfit font-medium text-[28px] leading-[32px] tracking-[0px]">
                  03
                </h1>
              </div>
              <h2 className="w-[85px] h-[31px] font-lora font-medium lg:text-[24px] lg:leading-[100%]  text-[14px]  leading-[18px] tracking-[0px] text-[#000000] mt-6">
                Go Live
              </h2>
              <p className="w-[269px] h-[48px] font-outfit font-[350] lg:text-[16px] text-[12px] lg:leading-[24px] leading-[20px]  tracking-[0px] text-[#767676] text-center mt-2">
                Start earning through our platform while we manage operations.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* <section className="flex flex-col justify-items items-center mt-[160px] md:mt-[176px] lg:mt-[256px] w-full ">
        <div className="relative mt-20 mb-20 px-4 lg:px-8 w-[362px] h-[877px] lg:w-[1300px] lg:h-[847px] md:w-[706px] md:h-[657px] rounded-lg">
          <div className="absolute inset-0 ">
            <img
              src="/images/Home/form.webp"
              alt="Background"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <div className="relative flex flex-col lg:flex-row md:flex-row items-start justify-between lg:p-10">
            <div
              className="text-white lg:text-left text-center mt-10"
              style={{
                width: "518px",
                height: "212px",
                gap: "26px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
            >
              <h2
                className="font-lora font-medium"
                style={{
                  width: "483px",
                  height: "98px",
                  fontSize: "38px",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                }}
              >
                <span className="block">Stay Connected With Us</span>
                <span className="block pt-[15px]">
                  for Assistance and Updates
                </span>
              </h2>

              <p
                className="font-outfit font-normal text-[16px] leading-[22px] tracking-[0%]"
                style={{
                  width: "506px",
                  height: "88px",
                  fontWeight: 400,
                  marginTop: "20px",
                }}
              >
                We’re here to assist you! Whether you have questions, need
                support, or want to share your feedback, simply fill out the
                form below. Our team will get back to you promptly. Let’s stay
                connected and make your experience with Znorm Homes even better!
              </p>
            </div>

            <div className="bg-[#FFFFFF] mt-4 rounded-lg shadow-lg lg:w-[626px] lg:h-[767px] md:w-[340px] md:h-[609px] w-[330px] h-[609px] px-4 lg:py-4">
              <h3 className="font-lora font-medium text-[24px] leading-[32px] tracking-[0.5%] text-center mb-4 lg:mt-4">
                Keep in touch
              </h3>
              <p className="font-outfit font-[350] text-[16px] leading-[24px] tracking-[0px] text-[#707070] text-center mb-6">
                Fill out the form, and we will get back to you soon. Let's stay
                connected!
              </p>
              <ContactForm />
            </div>
          </div>
        </div>
      </section> */}
        <section className="flex flex-col justify-items items-center mt-[160px] md:mt-[176px] lg:mt-[256px] w-full  lg:px-[105px] md:px-[64px] px-4 ">
              <div className="relative mt-20 mb-20 w-full max-w-[1300px] h-auto rounded-[31px]">
                <div className="absolute inset-0">
                  <img
                    src="/images/Home/form.webp"
                    alt="Background"
                    className="w-full h-full object-cover  rounded-[31px]"
                  />
                </div>
                <div className="relative flex flex-col lg:flex-row md:flex-row items-start justify-between p-6 lg:px-10 gap-8">
                  {/* Left Section: Text */}
                  <div className="text-white lg:text-left text-center w-full lg:w-[518px] md:w-[274px] lg:mt-[116px] space-y-6">
                    <h2 className="font-lora font-medium  lg:text-[38px] lg:leading-[100%] text-[18px] leading-[26px] ">
                      Stay Connected With Us
                      <br />
                      for Assistance and Updates
                    </h2>
                    <p className="font-outfit text-[12px] lg:leading-[20px] lg:text-[16px] leading-[22px] opacity-90">
                      We're here to assist you! Whether you have questions, need
                      support, or want to share your feedback, simply fill out the
                      form below. Our team will get back to you promptly. Let's stay
                      connected and make your experience with Znorm Homes even better!
                    </p>
                  </div>
      
                  {/* Right Section: Contact Form */}
                  <div className="bg-white rounded-lg shadow-lg w-full lg:w-[626px] md:w-[340px] p-4 lg:p-8">
                    <h3 className="ffont-lora font-medium text-[24px] leading-[32px] tracking-[0.5%] text-center mb-4 lg:mt-4">
                      Keep in touch
                    </h3>
                    <p className="font-outfit font-[350] text-[16px] leading-[24px] tracking-[0px] text-[#707070] text-center mb-6">
                      Fill out the form, and we will get back to you soon. Let's stay
                      connected!
                    </p>
                    <ContactForm />
                  </div>
                </div>
              </div>
            </section>

      <section className=" flex flex-col justify-center  items-center w-full lg:h-[280px] h-[196px] lg:px-[106px] lg:mt-[200px] mt-[96px]  bg-[#ECF1E3] ">
        <div className="flex flex-row items-center justify-between  w-full lg:w-[1300px] lg:py-[76px] py-10  mx-auto">
          <div className="lg:w-[515px] lg:h-[128px] w-[236px] h-[116px] flex flex-col lg:ml-0 ml-[16px]">
            <h2 className="text-[18px] lg:text-[24px] text-start font-lora font-medium text-[#1E1E1E] lg:mb-8 mb-6 ">
              Ready to become a partner?
            </h2>

            <button className="bg-[#9ABB7A] text-white rounded-md font-outfit text-[12px] lg:text-[16px] lg:leading-[22px] leading-[20px] w-[120px] h-[40px] lg:w-[148px] lg:h-[48px]  py-2">
              Join Our Team
            </button>
          </div>
          <div className="w-[196px] h-[196px] lg:w-[681px] lg:h-[280px]">
            <img
              src="/images/Partnership/Partnership1.webp"
              alt="Partner Illustration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>
    </>
  );
};
export default Partnership;
